import { render } from "./PopupShareReport.vue?vue&type=template&id=cc1067d6"
import script from "./PopupShareReport.vue?vue&type=script&lang=js"
export * from "./PopupShareReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__